import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

/**
 * @ngdoc service
 * @name OpenAmountService
 * @module OpenAmountModule
 *
 * @description
 * Service to store and retrieve the status for the result page
 **/
@Injectable({
    providedIn: 'root'
})
export class OpenAmountService {
    public static getOpenAmountFormControl(maximumValueBedrag: number): FormControl<number> {
        const minimumValueBedrag = 0.01;
        const defaultMaximumValueBedrag = 750;

        return new FormControl<number>(null, {
            validators: [
                Validators.required,
                Validators.min(minimumValueBedrag),
                Validators.max(maximumValueBedrag ?? defaultMaximumValueBedrag)
            ]
        });
    }
}
